
export const quotes = [{
  title: "Empower Through Healing",
  text: "Every patient you guide is a life you uplift. Compassion is the prescription that always works."
},
{
  title: "Transform One Life, Transform Many",
  text: "When you help someone feel whole again—balanced, understood, and seen—you start a ripple effect of health."
},
{
  title: "Science with Soul",
  text: "Clinical expertise meets human connection. That’s where true healing happens."
},
{
  title: "Hormones, Hope, and Healing",
  text: "To your patients, you’re not just a doctor—you’re a guide through some of the most vulnerable chapters of their lives."
},
{
  title: "Every Step Matters",
  text: "In every small success—a pound lost, a symptom relieved, a patient reassured—there is victory."
},
{
  title: "Restoring Balance, Rebuilding Confidence",
  text: "Helping patients feel like themselves again is more than treatment—it’s transformation."
},
{
  title: "Guided by Care, Grounded in Knowledge",
  text: "Great medicine treats the body. Great doctors treat the person."
},
{
  title: "The Power of Listening",
  text: "Sometimes the most healing thing a doctor can do is listen with empathy and without hurry."
},
{
  title: "Progress, Not Perfection",
  text: "Small wins lead to big transformations. Every step forward is a step toward healing."
},
{
  title: "Balance Is Possible",
  text: "Hormonal health is a puzzle—your care helps patients put the pieces back together."
},
{
  title: "Your Knowledge Changes Lives",
  text: "For patients navigating fatigue, weight gain, or mood swings, your expertise is their anchor."
},
{
  title: "Compassion is Clinical Excellence",
  text: "Great care isn’t just found in prescriptions—it’s in the way you show up for your patients."
},
{
  title: "You Are the Difference",
  text: "In a world of symptoms and side effects, you provide clarity and confidence."
},
{
  title: "Healing Starts with Trust",
  text: "When patients feel heard and safe, healing begins—even before the labs come back."
},
{
  title: "Hope Has a Name: You",
  text: "To the struggling woman on the other side of the screen, your guidance is the hope she’s been seeking."
},
{
  title: "Restore What’s Been Lost",
  text: "Energy, confidence, peace of mind—your care helps bring it all back."
},
{
  title: "Medicine with Heart",
  text: "Science gives answers. Compassion gives patients the strength to follow through."
},
{
  title: "You Make the Complex Clear",
  text: "Hormones are confusing. You turn confusion into empowerment."
},
{
  title: "Guiding Through the Fog",
  text: "When life feels off balance, you help patients find solid ground again."
},
{
  title: "Reclaiming Identity, One Visit at a Time",
  text: "With every consult, you help someone feel like themselves again."
},
{
  title: "You Treat the Story, Not Just the Symptoms",
  text: "Behind every lab result is a human story. You honor both."
},
{
  title: "Care That Goes Beyond Protocol",
  text: "Protocols guide treatment. Your intuition and empathy complete the care."
}
];